<div class="modal-header">
  @if (isNewSupportContact) {
    <h4 class="modal-title h5" translate>New support contact</h4>
  }
  @if (!isNewSupportContact) {
    <h4 class="modal-title h5" translate>Edit support contact</h4>
  }
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form [formGroup]="contactForm" (ngSubmit)="onSave()">
  <div class="modal-body modal-contacts">

    <div class="row">

      <div class="col-12 col-lg-6">
        <!-- TYPE-->
        <div class="form-group">
          <label for="type" translate>Department</label>
          <input name="type" formControlName="type"
            id="type"
            type="text"
            class="form-control"
            [ngClass]="{ 'is-invalid': submitted && f.type.errors }">

            @if (submitted && f.type.errors) {
              <div class="invalid-feedback">
                @if (f.type.errors.required) {
                  <span translate>Support contact department required</span>
                }
              </div>
            }
          </div>

          <!-- NAME-->
          <div class="form-group">
            <label for="name" translate>Name</label>
            <input name="name" formControlName="name"
              id="name"
              type="text"
              class="form-control"
              [ngClass]="{ 'is-invalid': submitted && f.name.errors }">

              @if (submitted && f.name.errors) {
                <div class="invalid-feedback">
                  @if (f.name.errors.required) {
                    <span translate>Support contact name required</span>
                  }
                </div>
              }
            </div>

            <!-- EMAIL-->
            <div class="form-group">
              <label for="email" translate>Email</label>
              <input name="email" formControlName="email"
                id="email"
                type="email"
                class="form-control"
                [ngClass]="{ 'is-invalid': submitted && f.email.errors }">

                @if (submitted && f.email.errors) {
                  <div class="invalid-feedback">
                    @if (f.email.errors.required) {
                      <span translate>Support contact email required</span>
                    }
                    @if (f.email.errors.email) {
                      <span translate>Support contact email invalid</span>
                    }
                  </div>
                }
              </div>

              <!-- PHONE-->
              <div class="form-group">
                <label for="phone" translate>Phone</label>
                <input name="phone" formControlName="phone"
                  id="phone"
                  type="tel"
                  class="form-control"
                  [ngClass]="{ 'is-invalid': submitted && f.phone.errors }">

                  @if (submitted && f.phone.errors) {
                    <div class="invalid-feedback">
                      @if (f.phone.errors.required) {
                        <span translate>Support contact phone required</span>
                      }
                    </div>
                  }
                </div>

              </div>

              <!-- IMAGE-->
              <div class="col-12 col-lg-6">
                <div class="card card-preview text-center">
                  <span class="badge badge-success preview-tag" translate>Preview</span>
                  <div class="card-body">
                    <h4 class="h4 pt-1">
                      @if (!f.type.value) {
                        <span><span translate>Department</span></span>
                      }
                      @if (f.type) {
                        <span [innerText]="f.type.value"></span>
                      }
                    </h4>
                    <div class="avatar">
                      <img [src]="contact.image" class="avatar"
                        (click)="uploader.click()" alt="">

                        <span class="btn btn-primary btn-upload-image"
                          (click)="uploader.click()">
                          <span class="fa-solid fa-camera"></span>
                          <span translate>Image upload</span>
                        </span>

                        <input [hidden]="true" type="file"
                          #uploader
                          accept="image/*"
                          class="custom-file-input"
                          (change)="onImageChange($event)"/>
                        </div>
                        <div class="contact-info">
                          <strong>
                            @if (!f.name.value) {
                              <span><span translate>John Doe</span></span>
                            }
                            @if (f.name.value) {
                              <span [innerText]="f.name.value"></span>
                            }
                          </strong><br>
                          <span>
                            @if (!f.phone.value) {
                              <span><strong>Tel</strong> 123456789</span>
                            }
                            @if (f.phone.value) {
                              <span><strong>Tel</strong> <span [innerText]="f.phone.value"></span></span>
                            }
                          </span><br>
                          <span>
                            @if (!f.email.value) {
                              <span>name&#64;example.com</span>
                            }
                            @if (f.email.value) {
                              <a [href]="'mailto:'+f.email.value">
                                <span [innerText]="f.email.value"></span>
                              </a>
                            }
                          </span><br>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-outline-primary"
                  (click)="onCancel()">
                  <span translate>Cancel</span>
                </button>
                <button [disabled]="isDisabledSaveBtn" type="submit" class="btn btn-primary">
                  <span translate>Save</span>
                </button>
              </div>
            </form>
